import { ProductAvailabilityGtmEvents } from '@/gtm/product/product-availability-gtm-events';
import { ProductCardCtaGtmEvents } from '@/gtm/product/product-card-cta-gtm-events';
import { ProductCardGtmEvents } from '@/gtm/product/product-card-gtm-events';
import { ProductKitGtmEvents } from '@/gtm/product/product-kit-gtm-events';
import { ProductListItemGtmEvents } from '@/gtm/product/product-list-item-gtm-events';
import { ProductQuickViewGtmEvents } from '@/gtm/product/product-quick-view-gtm-events';
import { ProductReviewsGtmEvents } from '@/gtm/product/product-reviews-gtm-events';

export const productGtmEvents = {
  card: new ProductCardGtmEvents(),
  quickView: new ProductQuickViewGtmEvents(),
  reviews: new ProductReviewsGtmEvents(),
  availability: new ProductAvailabilityGtmEvents(),
  productListItem: new ProductListItemGtmEvents(),
  productKit: new ProductKitGtmEvents(),
  cta: new ProductCardCtaGtmEvents(),
};
